////    CORE    ////
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

////    COMPONENTS    ////
import { LoginComponent } from './login.component'
import { IconModule, LoaderButtonModule } from '@helvetia/components'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { MaterialImporterModule } from 'src/app/shared/material-importer/material-importer.module'

@NgModule({
  declarations: [LoginComponent],
  imports: [
    AppRoutingModule,
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    LoaderButtonModule,
    MaterialImporterModule
  ],
})
export class LoginModule {}
